





























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Factor, FactorGroup, FactorResource } from "@/api/model/FactorResource";
import { Choice } from "@/api/model/Choice";

@Component({
    components: {}
})
export default class QuestionnaireFactorNavigationPanel extends Vue {

    @Prop()
    name!: string;

    @Prop()
    choiceData!: Choice;

    @Prop()
    factorResources!: { [id: string]: FactorResource };

    @Prop({ type: Boolean, default: false })
    disabled!: boolean;

    @Prop()
    currentSelectedId!: string | null;

    @Prop({type: Array, default: () => []})
    questionFactors!: any[];

    @Prop({
        type: Object,
        default: () => ({})
    })
    styles!: any;

    private open: any[] = [];
    private activeItems: string[] = this.currentSelectedId ? [this.currentSelectedId] : [];

    get items() {
        return this.constructSubTree(this.factorResources, 'M');
    }

    @Watch('currentSelectedId')
    private onCurrentSelectedId() {
        if (!this.currentSelectedId) {
            this.activeItems = [];
            return;
        }
        this.activeItems = [this.currentSelectedId]
        let path = this.findPath(this.currentSelectedId, 'M', this.factorResources);
        if (path) {
            this.open = path;
        }
        //@ts-ignore
        setTimeout(() => this.$vuetify.goTo('#tree-' + this.currentSelectedId, {
            container: '#tree-view-container',
            offset: 300,
            duration: 100
        }), 100)
    }

    private findPath(searchId: string, currentId: string, factorResources: { [id: string]: FactorResource }): string[] | undefined {
        let factorResource = factorResources[currentId];
        if (factorResource.type === 'FACTOR_GROUP') {
            if ((factorResource as FactorGroup).childrenIds.includes(searchId)) {
                return [currentId]
            }
            for (let childId of (factorResource as FactorGroup).childrenIds) {
                let subsearch = this.findPath(searchId, childId, factorResources);
                if (subsearch) {
                    return [currentId, ...subsearch]
                }
            }
        }
    }


    private constructSubTree(resources: { [id: string]: FactorResource }, factorGroupId: string): any {
        return (resources[factorGroupId] as FactorGroup).childrenIds
            .map(fId => resources[fId])
            .filter(r => r && r.numWeightingDots || 0 > 0)
            .map(f => {
                if (f.type === 'FACTOR_GROUP') {
                    return {
                        id: f.id,
                        name: f.name,
                        type: 'FACTOR_GROUP',
                        isTable: (f as FactorGroup).groupTypeDefinition && (f as FactorGroup).groupTypeDefinition.type.startsWith('TABLE'),
                        groupTypeDefinition: (f as FactorGroup).groupTypeDefinition,
                        children: !(f as FactorGroup).groupTypeDefinition || !(f as FactorGroup).groupTypeDefinition.type.startsWith('TABLE') ? this.constructSubTree(resources, f.id) : []
                    }
                }
                return {
                    id: f.id,
                    name: f.name,
                    type: 'FACTOR',
                    dataField: f.dataField,
                    valueTypeDefinition: (f as Factor).valueTypeDefinition
                }
            })
    }

    private isSubsectionComplete(group: any) {
        if (group.isTable) {
            let table = this.factorResources[group.id] as FactorGroup
            if (table.groupTypeDefinition.type === 'TABLE_GROWING') {
                return !table.childrenIds.map(id => this.factorResources[id])
                    .find(f => this.choiceData[f.dataField || ''] == null)
            } else {
                return !table.childrenIds.map(id => this.factorResources[id] as FactorGroup)
                    .filter(fg => fg.groupTypeDefinition.type === 'TABLE_ROW')
                    .map(fg => fg.childrenIds)
                    .flat()
                    .map(id => this.factorResources[id] as Factor)
                    .find(f => this.choiceData[f.dataField || ''] == null)
            }
        }
        if (!group.children || group.children.length === 0) return true;
        const falseFound = group.children
            .map((child: any) => {
                if (child.type === 'FACTOR_GROUP') {
                    return this.isSubsectionComplete(child);
                }
                if (this.choiceData[child.dataField] == null) return false;
                return true;
            })
            .find((b: boolean) => !b)
        if (falseFound === false) return false;
        return true;
    }
}
